import React, { useState, useCallback } from 'react';
import { Trans } from '@lingui/react/macro';
import { Modal, ModalHeader, ModalBody } from '@ygtechnologies/bygr-frontend-component-library';
import DocumentUpload from '../DocumentUpload';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';

type Props = {
    residentialUnitId?: number;
    isOpen: boolean;
    disableDrop?: boolean;
    document: any;
    projectId: number;
    onClose?: () => void;
    onSave: () => void;
};

const DocumentUploadDialog: React.FC<Props> = ({
    isOpen,
    residentialUnitId,
    onSave,
    disableDrop,
    projectId,
    document,
    onClose,
}) => {
    const [key, setKey] = useState(1);

    const onOpen = useCallback(() => {
        setKey(key + 1);
    }, [key]);

    const handleClose = useCallback(() => {
        triggerHandler(onClose);
    }, [onClose]);

    return (
        <Modal size="lg" toggle={handleClose} isOpen={isOpen} onOpen={onOpen}>
            <ModalHeader>
                <Trans>Upload document</Trans>
            </ModalHeader>

            <ModalBody>
                <DocumentUpload
                    key={key}
                    onClose={handleClose}
                    document={document}
                    projectId={projectId}
                    disableDrop={disableDrop}
                    onSave={onSave}
                    residentialUnitId={residentialUnitId}
                />
            </ModalBody>
        </Modal>
    );
};

export default DocumentUploadDialog;
